import alterpressApi from './base';

import { TRegisterFormInitialProps } from '../../formik/registration.form';
import { IPasswordResetData, IUserData } from '../../models/user.model';
import { TLoginFormInitialValues } from '../../formik/login.form';

const userExpandParams = `expand=cart,newsletters,profile`;

export const userApi = alterpressApi
    .enhanceEndpoints({
        addTagTypes: ['User'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            loginUser: builder.mutation<IUserData, TLoginFormInitialValues>({
                query: (data) => ({
                    method: 'POST',
                    url: `account/login?${userExpandParams}`,
                    body: data,
                }),
            }),
            registerUser: builder.mutation<IUserData, TRegisterFormInitialProps>({
                query: (data) => ({
                    method: 'POST',
                    url: `account/register?${userExpandParams}`,
                    body: data,
                }),
            }),
            getUser: builder.query<IUserData, void>({
                query: () => `account?${userExpandParams}`,
            }),
            verifyUser: builder.mutation<void, string>({
                query: (token) => `account/activate/${token}`,
            }),
            logoutUser: builder.mutation<void, void>({
                query: () => ({
                    method: 'POST',
                    url: 'account/logout',
                }),
            }),
            passwordRecovery: builder.mutation<void, void>({
                query: (data) => ({
                    method: 'POST',
                    url: 'account/password-reset-request',
                    body: data,
                    headers: {
                        'Accept-Language': 'en',
                    },
                }),
            }),
            passwordReset: builder.mutation<{ email: string }, IPasswordResetData>({
                query: (data) => ({
                    method: 'POST',
                    url: 'account/password-reset',
                    body: data,
                }),
            }),
        }),
    });

export const {
    useLoginUserMutation,
    useRegisterUserMutation,
    useGetUserQuery,
    useVerifyUserMutation,
    useLogoutUserMutation,
    usePasswordRecoveryMutation,
    usePasswordResetMutation,
} = userApi;
